import { ref } from "vue";

const visible = ref(false);
const activeTab = ref("document"); // 'document' | 'project'

// null = "Documents" (no project), string = specific projectId
const contextProjectId = ref(null);

export function useAddModal() {
  // projectId: the project the user is currently viewing, or null = Documents
  function openDocument(projectId = null) {
    contextProjectId.value = projectId;
    activeTab.value = "document";
    visible.value = true;
  }
  function openProject() {
    contextProjectId.value = null;
    activeTab.value = "project";
    visible.value = true;
  }
  function close() {
    visible.value = false;
  }
  return { visible, activeTab, contextProjectId, openDocument, openProject, close };
}
